import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-[11px] tracking-[0.25em] uppercase text-primary-400 mb-2">
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl md:text-2xl tracking-wide text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-6">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}